import { render, staticRenderFns } from "./TemplateItem.vue?vue&type=template&id=98f38d6e&scoped=true&"
import script from "./TemplateItem.vue?vue&type=script&lang=js&"
export * from "./TemplateItem.vue?vue&type=script&lang=js&"
import style0 from "./TemplateItem.vue?vue&type=style&index=0&id=98f38d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f38d6e",
  null
  
)

export default component.exports